<template>
  <div>
    <!-- <b-card
      class="shadow"
      bg-variant="secondary"
      header-text-variant="light"
      header-tag="h6"
      :header="title"
    > -->
      <filters v-if="!nofilter" @remove="removeFilter" :filters="filters" class="mb-3"></filters>
      <slot name="info"></slot>
      <b-table
        responsive
        v-if="items.length > 0"
        striped
        small
        :select-mode="selectMode"
        hover
        :primary-key="idTable ? idTable : 'ID'"
        :selectable="selectMode ? true : false"
        selected-variant="success"
        no-local-sorting
        :items="items"
        :fields="fields"
        @sort-changed="sortChanged"
        @row-clicked="$emit('row-clicked', $event)"
      >
       
        <template v-for="slotName in Object.keys($scopedSlots)" v-slot:[slotName]="slotScope">
          <slot :name="slotName" v-bind="slotScope">
            
          </slot>
          
        </template>
        <template v-slot:cell()="data">
          <span v-html="highlight(data.value)"></span> 
        </template>
      </b-table>
      <b-alert show v-else>Aucun résultat</b-alert>
      <pagination :nofloatingPagination="nofloatingPagination" @changePage="changePage" :info="pagination"></pagination>
    <!-- </b-card> -->
  </div>
</template>

<script>
import Filters from "@/components/Filters.vue";
import Pagination from "@/components/Pagination.vue";
export default {
  name: "list",
  components: { Filters, Pagination },
  props: {
    idTable: String,
    items: Array,
    
    nofloatingPagination: {
      type: Boolean,
      default: false
    },
    nofilter: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Résultats"
    },
    selectMode: String,
    search: {
      type: String,
      default: function() {
        return "";
      }
    },
    filters: {
      type: [Object, Array],
      default: function() {
        return { search: "" };
      }
    },
    fields: {
      type: Array,
      default: function() {
        return [];
      }
    },
    pagination: {
      type: Object,
      default: function() {
        return {
          page: 1,
          numberOfPages: 1
        };
      }
    },
    actions: {
      type: Array,
      default: function() {
        return [];
      }
    },
    sortBy: {
      type: String,
      default: function() {
        return "";
      }
    },
    sortDesc: {
      type: Boolean,
      default: function() {
        return false;
      }
    }
  },

  methods: {
    highlight(str) {
      
      if (!this.search) {
        return str;
      }
      return String(str).replace(new RegExp(this.search, "gi"), match => {
        return '<span class="highlightText">' + match + "</span>";
      });
    },
    sortChanged(ctx) {
      if (ctx.sortBy !== "") {
        this.$emit("changeSort", ctx);
      }
    },
    changePage(page) {
      this.$emit("changePage", page);
    },
    removeFilter(index) {
      this.$emit("removeFilter", index);
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

.table-hover {
  tbody tr {
    transition: all 0.5s;
    &:hover {
      background-color: $info !important;
    }
  }
}


</style>